function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Valentines = ({
  style,
  color,
  ...rest
}) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 33 45",
  style: {
    width: 36,
    height: 50,
    ...style
  }
}, rest), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE76C",
  d: "M28.3,8.6c0-1-0.5-1.8-1-2.4C27,5.7,26.8,5.3,26.8,5c0-0.8,0.4-1.2,0.4-1.2l0,0c0.2-0.2,0.2-0.5,0-0.7 c-0.2-0.2-0.5-0.2-0.7,0c-0.1,0.1-0.7,0.7-0.7,1.9c0,0.6,0.4,1.2,0.7,1.7c0.4,0.6,0.8,1.2,0.8,1.9c0,1.1-1,2.7-1.4,3.3 c-0.1,0.2-0.1,0.4,0,0.6c0.4,0.5,1.4,2.2,1.4,3.3c0,0.7-0.4,1.3-0.8,1.9c-0.4,0.6-0.7,1.1-0.7,1.7c0,1.2,0.6,1.8,0.7,1.9 c0.1,0.1,0.3,0.2,0.5,0.1c0.2,0,0.3-0.2,0.4-0.4c0-0.2,0-0.4-0.1-0.5l0,0c0,0-0.4-0.4-0.4-1.2c0-0.3,0.3-0.7,0.6-1.1 c0.4-0.6,1-1.4,1-2.4c0-1.3-1-2.9-1.4-3.6C27.3,11.5,28.3,9.9,28.3,8.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE76C",
  d: "M26.2,19.9c-0.2,0-0.3-0.1-0.4-0.2l-5.2-7.2c-0.1-0.2-0.1-0.4,0-0.6l5.2-7.2c0.2-0.2,0.5-0.3,0.7-0.1 c0.2,0.2,0.3,0.5,0.1,0.7l-4.9,6.9l4.9,6.9c0.1,0.2,0.1,0.4,0,0.5S26.4,19.9,26.2,19.9L26.2,19.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE76C",
  d: "M31.9,12.7h-6.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.7c0.3,0,0.5,0.2,0.5,0.5S32.2,12.7,31.9,12.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95573A",
  d: "M21.5,1c-0.5,0-0.9,0.2-1.3,0.4C19.9,0.6,19,0.1,18.1,0c-0.9,0-1.8,0.4-2.3,1.2c-1-0.5-2.2-0.1-2.7,0.9 c-0.5,1-0.1,2.2,0.8,2.7c-0.9,0.5-1.3,1.5-0.9,2.4c0.3,0.9,1.3,1.5,2.3,1.3c1-0.2,1.7-1,1.7-2H20l0.7-1.7c0.8,0.3,1.7,0.2,2.3-0.4 c0.6-0.6,0.8-1.5,0.5-2.2C23.1,1.5,22.4,1,21.5,1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A7B6C1",
  d: "M15.3,11.8c0,0-5.1-2.5-6.7-6.6c0,0-5.7,3.1-5.7,6.1c0,2,2.6,1,3.6,0c0,0-1,3.6,2.6,1.5c0,0-0.5,3.1,3.1,1.5 L15.3,11.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7CCA9",
  d: "M10.2,19.2l-4,5.9c-0.3,0.5-0.2,1.1,0.2,1.4l2.5,1.9c0.5,0.3,1.1,0.2,1.4-0.2l0.3-0.4c0.3-0.5,0.2-1.1-0.2-1.4 l-1.2-0.9l4.6-4.1L10.2,19.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7CCA9",
  d: "M27.6,12.3c0,0.8-0.7,1.5-1.6,1.5h-6.2c0,0,0,4.6-3.1,6.1l1.7,3c0.2,0.4,0.2,0.8-0.1,1.2l-2.1,2.5l1.1,0.6 c0.5,0.3,0.7,0.9,0.5,1.4l-0.1,0.3c-0.2,0.5-0.8,0.7-1.3,0.5L13.7,28c-0.3-0.1-0.5-0.3-0.6-0.6c-0.1-0.3-0.1-0.6,0.1-0.8l1.5-2.6 c0,0-6.2-3.6-5.7-6.6s4.1-3.6,5.7-6.1c1.6-2.5,1.6-3.6,1.6-3.6l-0.6-0.8c-0.3-0.4-0.2-0.9,0.1-1.3L16,5.3C16.2,5.2,16.5,5,16.8,5 c0.3,0,0.5,0.1,0.7,0.3l0.8,0.8L19.5,5c0.3-0.3,0.7-0.4,1.1-0.2c0.4,0.1,0.6,0.4,0.7,0.8c0.1,0.7,0.1,1.4,0.2,2.1 c0,2-2.6,3.1-2.6,3.1h7.2C26.9,10.7,27.6,11.4,27.6,12.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#829AAD",
  d: "M16.8,20c-0.1,0.1-3.1-0.8-5.9,1.2C9.7,20,8.8,18.7,9,17.4c0.3-1.6,1.4-2.5,2.6-3.4L16.8,20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB423F",
  d: "M30.2,10.4c-0.3,0.4-0.3,1.1,0,1.5l0.3,0.3l-0.3,0.3c-0.3,0.4-0.3,1.1,0,1.5c0.2,0.2,0.4,0.3,0.6,0.3 c0.2,0,0.5-0.1,0.6-0.3l1.5-1.8l-1.5-1.8c-0.2-0.2-0.4-0.3-0.6-0.3C30.5,10.1,30.3,10.2,30.2,10.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C419",
  d: "M28.9,34.8h3.4c0.3,0,0.6,0.3,0.6,0.6v1.1c0,0.3-0.3,0.6-0.6,0.6h-2.9L28.9,34.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M32.9,27.9c0,4.6-2.6,8.1-3.6,9.2c-0.2,0.2-0.5,0.4-0.9,0.4H0.6c0,0-1.1-5.8,0-9.6c0.9-2.9,2.3-5.7,1.7-8.5 c-0.3-1.7-0.7-3-0.5-4.4c0-0.4,0.4-0.7,0.7-0.7c0.4,0,0.7,0.2,0.8,0.6c0.9,2.8,3.4,6.8,10.3,6.8c9.6,0,14.2-2.7,15.9-4.1 c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0.2,0.4,0.3C31.2,19.4,32.9,23.5,32.9,27.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M32.9,27.9c-0.1,3.4-1.3,6.6-3.6,9.2c-0.2,0.2-0.5,0.4-0.8,0.4h-1.1c0.3,0,0.6-0.1,0.8-0.4 c1.7-2,2.8-4.4,3.3-6.9c0.7-3.9-0.6-8.8-2.2-12.3c0.3-0.2,0.3-0.3,0.3-0.3c0.2-0.1,0.4-0.1,0.5,0l0,0c0.1,0.1,0.2,0.1,0.2,0.2 c0.1,0.2,0.5,1,0.7,1.5C32.2,22.1,32.9,25,32.9,27.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C419",
  d: "M30.3,19.8c-4.3,2.7-9.5,4-16.6,4c-4.1,0-9.5-1.1-11.8-7.2l0,0c-0.1-0.6-0.1-1.2,0-1.8c0-0.4,0.4-0.7,0.7-0.7 s0.7,0.2,0.8,0.6c0.9,2.9,3.4,6.9,10.3,6.9c11.6,0,15.7-4,16-4.2c-0.1,0.1-0.2,0.2-0.3,0.3C29.6,18.2,30,18.9,30.3,19.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F29C1F",
  d: "M31.2,19.4L31.2,19.4c-0.3,0.2-0.6,0.4-0.9,0.6c-0.3-0.9-0.7-1.7-0.9-2.2c0.1-0.1,0.2-0.1,0.3-0.2 c0.2-0.2,0.4-0.2,0.6,0l0,0c0,0,0.1,0.1,0.1,0.1C30.7,18.3,31,18.8,31.2,19.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M9.6,26.8c-2.7,0-5.2,1.2-7,3.3c-1.7,2.1-2.4,4.8-1.9,7.5H3c-0.7-2.7,0.4-5.6,2.7-7.3c2.3-1.6,5.4-1.6,7.7,0 c2.3,1.6,3.4,4.5,2.7,7.3h2.3c0.5-2.6-0.2-5.4-1.9-7.5C14.8,28,12.3,26.8,9.6,26.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M17.9,37.5H3.5c-0.7-2.9,0.5-6,3-7.7c2.5-1.7,5.9-1.7,8.4,0C17.4,31.5,18.6,34.6,17.9,37.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M10.7,34.2c-0.3,0-0.6-0.3-0.6-0.6v-4.5c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v4.5 C11.3,34,11,34.2,10.7,34.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M9.1,34.9c-0.2,0-0.3-0.1-0.4-0.2l-3.2-3.2c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0l3.2,3.2 c0.2,0.2,0.2,0.4,0.1,0.6C9.5,34.7,9.3,34.9,9.1,34.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M8.4,36.5H3.9c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h4.5c0.3,0,0.6,0.3,0.6,0.6 C9,36.2,8.8,36.5,8.4,36.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M5.9,41.3c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2,0-0.5,0.1-0.6l3.2-3.2c0.1-0.1,0.4-0.2,0.6-0.2 c0.2,0.1,0.4,0.2,0.4,0.4c0.1,0.2,0,0.4-0.2,0.5l-3.2,3.2C6.2,41.2,6,41.3,5.9,41.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M10.7,43.3c-0.3,0-0.6-0.3-0.6-0.6v-4.5c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v4.5 C11.3,43,11,43.3,10.7,43.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M15.5,41.3c-0.2,0-0.3-0.1-0.4-0.2l-3.2-3.2c-0.1-0.1-0.2-0.4-0.2-0.5c0.1-0.2,0.2-0.4,0.4-0.4 c0.2-0.1,0.4,0,0.6,0.2l3.2,3.2c0.2,0.2,0.2,0.4,0.1,0.6C16,41.1,15.8,41.3,15.5,41.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M17.5,36.5H13c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h4.5c0.3,0,0.6,0.3,0.6,0.6 C18.1,36.2,17.8,36.5,17.5,36.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F6E5D",
  d: "M12.3,34.9c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2,0-0.5,0.1-0.6l3.2-3.2c0.2-0.2,0.6-0.2,0.8,0 c0.2,0.2,0.2,0.6,0,0.8l-3.2,3.2C12.6,34.8,12.5,34.9,12.3,34.9z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#CBB292",
  d: "M1.8,35.9c0-5,4-9.1,9-9.1c5,0,9,4.1,9,9.1c0,5-4,9.1-9,9.1C5.9,45,1.8,40.9,1.8,35.9z M4.1,35.9 c0,3.8,3,6.8,6.8,6.8c1.8,0,3.5-0.7,4.8-2c1.3-1.3,2-3,2-4.8c0-3.8-3-6.8-6.8-6.8C7.1,29,4.1,32.1,4.1,35.9z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#A59078",
  d: "M2.8,35.9c0-4.3,3.5-7.9,7.9-7.9c4.4,0,7.9,3.5,7.9,7.9s-3.5,7.9-7.9,7.9C6.4,43.8,2.8,40.2,2.8,35.9z M4,35.9c0,3.7,3,6.7,6.8,6.7c1.8,0,3.5-0.7,4.8-2c1.3-1.3,2-3,2-4.8c0-3.7-3-6.7-6.8-6.7C7,29.1,4,32.2,4,35.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F29C1F",
  d: "M13.1,35.8c0,1.2-1,2.2-2.3,2.2c-1.2,0-2.3-1-2.3-2.2c0-1.2,1-2.2,2.3-2.2C12.1,33.5,13.1,34.5,13.1,35.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C419",
  d: "M12.6,35.2c0,0.9-0.5,1.7-1.3,2c-0.8,0.4-1.7,0.3-2.4-0.2c-0.5-0.7-0.5-1.6-0.1-2.3c0.4-0.7,1.2-1.2,2-1.2 c0.5,0,1,0.2,1.3,0.4C12.5,34.3,12.6,34.8,12.6,35.2z"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#F3D55B",
  cx: "10.2",
  cy: "35.4",
  rx: "1.1",
  ry: "1.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M28.4,27.5L28.4,27.5c-0.8,0.5-1.5,0.9-2.3,1.4C26,28.9,26,29,26,29.1c0,0.3,0,0.2,0.2,0.4 c0.1,0.1,0.2,0.1,0.3,0c0.7-0.4,1.3-0.8,2-1.2l0.1-0.1c0,0,0,0.1,0,0.1V32c0,0.1-0.1,0.2-0.2,0.3l-2.2,1.4c-0.3,0.2-0.6,0.4-1,0.6 c-0.1,0.1-0.3,0.1-0.4,0c-1.1-0.7-2.1-1.3-3.2-1.9c-0.1-0.1-0.2-0.2-0.2-0.3c0-1.2,0-2.4,0-3.6c0,0,0-0.1,0-0.1l0.1,0.1l3,1.8 c0.1,0,0.1,0.1,0.1,0.2c0,0.9,0,1.8,0,2.7V33c0,0.1,0,0.1,0.1,0.1l0.2,0.1c0.1,0,0.1,0,0.2,0l0.2-0.1c0.1,0,0.1-0.1,0.1-0.1 c0,0,0,0,0-0.1v-3c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.1L25,29.6l-3.3-2l-0.1-0.1l0.1-0.1l3.1-1.7c0.1-0.1,0.3-0.1,0.4,0 C26.2,26.3,27.3,26.9,28.4,27.5L28.4,27.5z"
}));

export default Valentines;